import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel';
import '../style.css';
import './scss/master.scss';


$(function(){
  $('.testimonials .owl-carousel').owlCarousel({
    items: 1,
    dots: true,
    autoplay: true,
    autoHeight: true,
    loop: true,
  });

  $('.footer-testimonials .owl-carousel').owlCarousel({
    items: 3,
    dots: true,
    autoplay: true,
    autoHeight: true,
    loop: true,
    responsive: {
      768: {
        items: 3
      },
      0: {
        items: 1
      },
    }
  });

  

  startActualListCarousel();

  /*
  if ( $(window).width() < 768 ) {
    startActualListCarousel();
  } else {
    $('.actual-list').addClass('off');
  }

  $(window).resize(function() {
    if ( $(window).width() < 768 ) {
      startActualListCarousel();
    } else {
      stopActualListCarousel();
    }
  });
  */

  function stopActualListCarousel() {
    var owl = $('.actual-list');
    owl.trigger('destroy.owl.carousel');
    owl.addClass('off');
  }

  function startActualListCarousel(){
    $('.actual-list').owlCarousel({
      items: 1,
      dots: true,
      nav: false,
      autoplay: true,
      autoHeight: true,
      loop: true,
      responsive: {
        768: {
          items: 3
        }
      }
    });
  }
 
});